// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"771":"df359e49","787":"6b716f41"}[chunkId] + ".chunk.js";
};